/*

Actual broadcasting of a MediaStream to a given file/uri

*/
import WebRTCOutput from "./WebRTCOutput";

const MediaPush = (props) => {
  let target;
  if (props.targetOverride && props.targetOverride != "") {
    target = props.targetOverride;
  } else {
    target = props.broadcastObj.target || "";
  }
  const type = props.broadcastObj?.type || "";

  if (target == "" || type == "") {
    return;
  }

  if (props.broadcastObj.type == "webrtc") {
    return (
      <WebRTCOutput
        target={target}
        streamBitrate={100000000}
        mediaRef={props.broadcastObj.mediaSourceRef?.current}
      />
    );
  }
};

export default MediaPush;
